

















import { defineComponent } from '@vue/composition-api';
import svgCom from '@/components/Svg/index';

export default defineComponent({
  name: 'Header',
  components: {
    svgCom,
  },
  props: {
    account: {
      type: Object,
      required: false,
    },
    loginState: {
      type: Boolean,
      required: false,
    },
  },
  setup(prop: any, { emit }: any) {
    const logout = () => {
      emit('logout');
    };

    return {
      logout,
      login() {
        emit('login');
      },
    };
  },
});
